import './webcrypto-shim.mjs'
export default window.crypto



//////////////////
// WEBPACK FOOTER
// ./node_modules/isomorphic-webcrypto/src/browser.mjs
// module id = 594
// module chunks = 0